import { call, put, takeLatest, select } from 'redux-saga/effects';
import pickBy from 'lodash/pickBy';
import { get } from 'lodash';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { GET } from '../consts/Methods';
import { getSortParams } from '../helpers/utils';
import { FETCH_MY_BETS, FETCH_MY_BETS_SUCCESS, FETCH_MY_BETS_FAIL } from '../redux/BetsTables';
import { SET_LOADER } from '../redux/Loader';
import { MY_BETS } from '../consts/navigation';

function* getMyBetsFlow() {
  try {
    yield put(SET_LOADER({ value: true, }));
    const sortData = yield select((state) => get(state, ['tables', MY_BETS, 'sort']));
    const queryValue = yield select((state) => get(state, ['tables', MY_BETS, 'queryValue']));
    const limitValue = yield select((state) => get(state, ['tables', MY_BETS, 'rowsPerPage']));
    const page = yield select((state) => get(state, ['tables', MY_BETS, 'page']));
    const vehicleType = yield select((state) => state.vehicleType.vehicleType);

    const params = pickBy(
      {
        ...getSortParams(sortData),
        query: queryValue,
        limit: limitValue,
        page,
      },
      (val) => Boolean(val)
    );

    const endpoint = `${apiRoot}/${vehicleType}/bets/my`;
    const myBets = yield call(apiCall, { method: GET, endpoint, params, });
    yield put(FETCH_MY_BETS_SUCCESS(myBets));
  } catch (error) {
    yield put(FETCH_MY_BETS_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* GetMyBets() {
  yield takeLatest(FETCH_MY_BETS, getMyBetsFlow);
}
